import { useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { Card, Modal } from 'react-bootstrap'
import { HeaderChartProps, mainSeason, modalSeason, toAbsoluteUrl } from '../../../../../../_metronic/helpers'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'
import SourceLink from '../../component/chartLinkData'
import DoctorSosRateGraph from '../component/DoctorSosRateChart'

interface ItemType {
  id: number
  title: string
  campaigns: number
  logo: string
  bgColor: string
}

const DashboardPage = () => {
  const [showSeasonModal, setShowSeasonModal] = useState(false)
  const [showDoctorSosRateModal, setShowDoctorSosRateModal] = useState(false)

  const [selectedDiagnosisCategories, setSelectedDiagnosisCategories] =
    useState<string>('IRA')
  const [selectedAgeClass, setSelectedAgeClass] = useState<string[]>(['0-200'])
  useEffect(() => {
    // We have to show toolbar only for dashboard page
    document.getElementById('kt_layout_toolbar')?.classList.remove('d-none')
    return () => {
      document.getElementById('kt_layout_toolbar')?.classList.add('d-none')
    }
  }, [])

  const HeaderChart = ({ season }: HeaderChartProps) => (
    <h2 className='text-primary bold'>
      {' '}
      Doctor visits for respiratory syndromes {season} (France - pediatrics only){' '}
      <OverlayTrigger
        placement='right'
        overlay={
          <Tooltip id='logo-tooltip' style={{ width: '300px' }}>
            <p>
              The doctor visits data in France is extracted from CompuGroup Medical
              information systems used by Paediatricians (InfanSoft ®). The system is
              used by more than 100 Paediatricians spread out across France, trained for
              quality of diagnosis, and equipped with in-consultation tests. Anonymized
              data collected during medical consultation of children 0 to 18 years old
              is extracted by Compugroup Medical and analysed by partenering with the
              ActiV research association.{' '}
            </p>
          </Tooltip>
        }
      >
        <img
          //className='mb-1'
          style={{ width: '12px' }}
          alt='logo'
          src={toAbsoluteUrl('/media/logos/ii.svg')}
        />
      </OverlayTrigger>
    </h2>
  )
  const HeaderSosRateChart = ({ season }: HeaderChartProps) => (
    <h2 className='text-primary bold'>
      {' '}
      SOS Medecins - Consultations for respiratory syndromes (France){' '}{season}{' '}
      <OverlayTrigger
        placement='right'
        overlay={
          <Tooltip id='logo-tooltip' style={{ width: '600px' }}>
            <p>
              SOS Médecins consultations for influenza/flu-like syndrome correspond to consultations with a medical diagnosis of influenza/flu-like syndrome made by physicians from SOS Médecins associations.
              SOS Médecins data come from medical activities (home visits and consultations) collected by 62 SOS Médecins associations, representing 95% of all SOS Médecins activities.
              The number of SOS Médecins consultations for influenza/flu-like syndrome, by age group and geographical area, is reported relative to the total number of SOS Médecins consultations for which at least one medical diagnosis is recorded, for the same age group and geographical area.
              Indicators for emergency department visits (data from the OSCOUR network) and SOS Médecins consultations for influenza/flu-like syndrome are derived from the syndromic surveillance system SurSaUD (Health Surveillance of Emergency Departments and Deaths).
            </p>
          </Tooltip>
        }
      >
        <img
          //className='mb-1'
          style={{ width: '12px' }}
          alt='logo'
          src={toAbsoluteUrl('/media/logos/ii.svg')}
        />
      </OverlayTrigger>
    </h2>
  )
  return (
    <>
      {/* <div className='mx-4'>
        <div className='row'>
          <Card className='mb-8'>
            <div className='card'>
              <div className='card-body'>
                <HeaderChart />
              </div>
              <Card.Body style={{ marginTop: '-35px' }} className='row'>
                <DoctorVisitsChart season={mainSeason} />
                <p className='card-text source row'>
                  <i style={{ fontSize: '12px' }}>
                    * The baseline represents the smoothed value from the previous year. Confidence
                    intervals are calculated by determining the critical value using the normal
                    distribution corresponding to a 95% confidence level. The standard deviation is
                    multiplied by this critical value to obtain the margins of error, which are then
                    added and subtracted from the sample mean to define the interval bounds. The
                    computed alert corresponds to a binary value of 0/1 for each week, diagnosis,
                    age group, geographical origin or/and RSS duration. It indicates, when equal to
                    1, that the current case count exceeds the upper bound of the baseline case
                    count.
                  </i>
                </p>
                <div className="d-flex justify-content-between align-items-center">
                  <p className='card-text source'>
                    <i>
                      Source:
                      <a className='fw-bold' href='https://www.cgm.com/corp_en'>
                        {' '}
                        The Activ association (French network of pediatricians ) and CompuGroup
                        Medical
                      </a>
                    </i>
                  </p>
                  <SourceLink onClick={() => setShowSeasonModal(true)} />
                </div>

              </Card.Body>
            </div>
          </Card>
          <Modal
            // size="xl"
            className="modal-xxl"
            show={showSeasonModal}
            onHide={() => setShowSeasonModal(false)}
            centered
          >
            <Modal.Header closeButton className='py-4'>
              <Modal.Title className='bold'>
                <HeaderChart season={'2023-2024'} />
              </Modal.Title>
            </Modal.Header>

            <Modal.Body >
              <DoctorVisitsChart season={modalSeason} />
              <p className='card-text source row'>
                <i style={{ fontSize: '12px' }}>
                  * The baseline represents the smoothed value from the previous year. Confidence
                  intervals are calculated by determining the critical value using the normal
                  distribution corresponding to a 95% confidence level. The standard deviation is
                  multiplied by this critical value to obtain the margins of error, which are then
                  added and subtracted from the sample mean to define the interval bounds. The
                  computed alert corresponds to a binary value of 0/1 for each week, diagnosis,
                  age group, geographical origin or/and RSS duration. It indicates, when equal to
                  1, that the current case count exceeds the upper bound of the baseline case
                  count.
                </i>
              </p>
              <div className="d-flex justify-content-between align-items-center">
                <p className='card-text source'>
                  <i>
                    Source:
                    <a className='fw-bold' href='https://www.cgm.com/corp_en'>
                      {' '}
                      The Activ association (French network of pediatricians ) and CompuGroup
                      Medical
                    </a>
                  </i>
                </p>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div> */}
      <div className='mx-4'>
        {/* begin::Row  */}
        <div className='row'>
          <Card className='mb-8'>
            <div className='card'>
              <div className='card-body'>
                <HeaderSosRateChart />
              </div>
              <Card.Body style={{ marginTop: '-35px' }} className='row'>
                <DoctorSosRateGraph
                  season={mainSeason}
                  selectedAgeClass={selectedAgeClass}
                  setSelectedAgeClass={setSelectedAgeClass}
                  selectedDiagnosisCategories={selectedDiagnosisCategories}
                  setSelectedDiagnosisCategories={setSelectedDiagnosisCategories}
                />
                <div className="d-flex justify-content-between align-items-center">
                  <p className='card-text source' style={{ maxWidth: '87%' }}>
                    <i>
                      Source:
                      <a className='fw-bold' href='#'>
                        {' '}
                        The indicators for monitoring SOS Médecins consultations are derived from the SurSaUD® syndromic surveillance system
                        {' '}
                        (Health Surveillance of Emergencies and Deaths)
                        .
                      </a>
                    </i>
                  </p>
                </div>
              </Card.Body>
            </div>
          </Card>
          <Modal
            // size="xl"
            className="modal-xxl"
            show={showDoctorSosRateModal}
            onHide={() => setShowDoctorSosRateModal(false)}
            centered
          >
            <Modal.Header closeButton className='py-4'>
              <Modal.Title className='bold'>
                <HeaderSosRateChart season={'2023-2024'} />
              </Modal.Title>
            </Modal.Header>

            <Modal.Body >
              <DoctorSosRateGraph
                season={modalSeason}
                selectedAgeClass={selectedAgeClass}
                setSelectedAgeClass={setSelectedAgeClass}
                selectedDiagnosisCategories={selectedDiagnosisCategories}
                setSelectedDiagnosisCategories={setSelectedDiagnosisCategories}
              />
              <p className='card-text source'>
                <p className='card-text source mt-2 row'>
                  <i style={{ fontSize: '12px' }} className=''>
                    * calculated based on historical values ​​(2020-2021 to 2024-2025)
                  </i>
                </p>
              </p>
              <div className="d-flex justify-content-between align-items-center">
                <p className='card-text source' >
                  <i>
                    Source:
                    <a className='fw-bold' href='#'>
                      {' '}
                      The indicators for monitoring SOS Médecins consultations for influenza/flu-like syndrome are derived from the SurSaUD® syndromic surveillance system
                      {' '}(Health Surveillance of Emergencies and Deaths)
                      .
                    </a>
                  </i>
                </p>
              </div>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    </>
  )
}

const DoctorVisits = () => {
  const intl = useIntl()
  return (
    <>
      <DashboardPage />
    </>
  )
}

export { DoctorVisits }
